import { memo, useMemo } from 'react';
import { Box, Icon, Text } from '@bonanza-social/moonlight';
import { RewardsTextProps } from './RewardsText.types';
import { aggregateRewards } from './RewardsText.utils';
import { REWARD_TEXT_CONFIG } from './RewardsText.content';

function RewardsText({ promos }: RewardsTextProps) {
  const aggregatedRewards = useMemo(() => aggregateRewards(promos), [promos]);

  return (
    <Box flexDirection="row" flexWrap="wrap" gap="space-200">
      {aggregatedRewards.map(({ type, amount }) => {
        const config = REWARD_TEXT_CONFIG[type];

        if (!config) {
          return null;
        }

        return (
          <Box
            key={type}
            flexDirection="row"
            gap="space-100"
            centerContent
            testID={`reward-item-${type}-${amount}`}
          >
            <Icon
              name={config.icon}
              gradient="accentBackground"
              width="space-400"
              height="space-400"
            />
            <Text variant="body-s" color="darkSurfacePrimary">
              {amount}
            </Text>
          </Box>
        );
      })}
    </Box>
  );
}

export default memo(RewardsText);
